import { BanIcon, CheckIcon } from 'lucide-react';
import { memo } from 'react';

import { useT } from '@/app/i18n/client';
import { cn } from '@/lib/utils';

interface IProps {
  included?: string;
  excluded?: string;
}

function ProductIncludedExcluded({ included, excluded }: IProps) {
  const { t } = useT('product');
  const includedItems = (included ?? '')
    .split(/\r?\n/)
    .map(s => s.trim())
    .filter(Boolean);
  const excludedItems = (excluded ?? '')
    .split(/\r?\n/)
    .map(s => s.trim())
    .filter(Boolean);

  if (includedItems.length === 0 && excludedItems.length === 0) return null;

  return (
    <div className='mb-12'>
      <h3 className='text-xl font-bold text-[#2E2E2E] max-sm:text-lg'>
        {t('inclusionsExclusions')}
      </h3>

      <div className='mt-3 grid grid-cols-1 gap-4'>
        {includedItems.length > 0 && (
          <section className='rounded-2xl border border-[#E9ECEF] bg-gray-50/50 p-3 sm:p-4'>
            <div className='mb-2 flex items-center gap-2'>
              <div className='flex h-5 w-5 items-center justify-center rounded-full bg-gray-100'>
                <CheckIcon className='h-3.5 w-3.5 text-gray-600' />
              </div>
              <span className='text-sm font-medium text-[#2E2E2E]'>{t('included')}</span>
              <span className='text-xs text-gray-400'>({includedItems.length})</span>
            </div>
            <div className={cn('grid grid-cols-1 gap-x-3 gap-y-2')}>
              {includedItems.map((item, idx) => (
                <div key={idx} className='flex items-start gap-2'>
                  <span className='break-words text-sm text-[#2E2E2E] max-sm:text-xs'>{item}</span>
                </div>
              ))}
            </div>
          </section>
        )}

        {excludedItems.length > 0 && (
          <section className='rounded-2xl border border-[#E9ECEF] bg-gray-50/50 p-3 sm:p-4'>
            <div className='mb-2 flex items-center gap-2'>
              <div className='flex h-5 w-5 items-center justify-center rounded-full bg-gray-100'>
                <BanIcon className='h-3.5 w-3.5 text-gray-600' />
              </div>
              <span className='text-sm font-medium text-[#2E2E2E]'>{t('excluded')}</span>
              <span className='text-xs text-gray-400'>({excludedItems.length})</span>
            </div>
            <div className={cn('grid grid-cols-1 gap-x-3 gap-y-2')}>
              {excludedItems.map((item, idx) => (
                <div key={idx} className='flex items-start gap-2'>
                  <span className='break-words text-sm text-[#2E2E2E] max-sm:text-xs'>{item}</span>
                </div>
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}

export default memo(ProductIncludedExcluded);
